import { pushEvent } from '../../client/data-layer';

/**
 * Tracks when the sorting of a product collection changes.
 * @param sort New sort mode
 */
export const trackProductCollectionSortUpdate = (sort: string) => {
  pushEvent('productCollectionSortUpdate', { sort });
};

/**
 * Tracks when a product collection quick filter panel is opened.
 * @param property Quick filter property
 */
export const trackProductCollectionQuickFilterOpen = (property: string) => {
  pushEvent('productCollectionQuickFilterOpen', {
    property,
  });
};

/**
 * Tracks when a product in a product collection is clicked.
 * @param productId ID of product clicked
 */
export const trackProductCollectionProductClick = (
  productId: string | number
) => {
  pushEvent('productCollectionProductClick', { productId });
};

/**
 * Tracks when product collection pagination is clicked
 * @param current Current page
 * @param page Clicked page
 * @param pageType Clicked page type
 */
export const trackProductCollectionPagination = (
  current: number,
  page: number,
  pageType: string
) => {
  pushEvent('productCollectionPagination', { current, page, pageType });
};

/**
 * Tracks when a link in the secondary navigation in product collection is clicked.
 * @param categoryUrl Url of category clicked
 */
export const trackProductCollectionSecondaryNavigationClick = (
  categoryUrl: string | number
) => {
  pushEvent('productCollectionSecondaryNavigationClick', { categoryUrl });
};

/**
 * Tracks when a link in the word cloud in product collection is clicked.
 * @param keywordId Url of keyword clicked
 */
export const trackProductCollectionWordCloudClick = (
  keywordUrl: string | number
) => {
  pushEvent('productCollectionWordCloudClick', { keywordUrl });
};

/**
 * Tracks when a user leaves feedback for a product collection
 * @param userMessage message that the user left
 */
export const trackProductCollectionUserProductFeedback = (
  userMessage: string
) => {
  pushEvent('productCollectionUserProductFeedback', { userMessage });
};
